import React, { useState, useEffect } from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import "../../styles/all.css";
import "../../styles/profil.css";
import { ThreeDots } from "react-loader-spinner";
import OrderDashboard from "./orderDashboard";

const Order = () => {
  const [json, setJson] = useState();
  const [orderLoading, setOrderLoading] = useState(false);

  const [searchInput, setSearchInput] = useState("");

  const [checked, setChecked] = useState(0);
  const [orderCheckbox] = useState([]);

  const radioCheckbox = [
    { name: "Commandes livrées", value: "delivered" },
    { name: "Commandes envoyées", value: "send" },
    { name: "En attente", value: "pending" },
  ];

  useEffect(() => {
    const token = localStorage.getItem("jwt");
    async function getAllOrder() {
      let { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}/order/orderadmin`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setJson(data);
      setOrderLoading(true);
    }
    getAllOrder();
  }, []);

  return (
    <div className="bgcolorffffff p-xl-5">
      <div className="p-xl-5">
        <div>
          <div className="m-5">
            <h5 className="text-center font-size-1_6">
              Gestion des commandes clients
            </h5>
          </div>
          <div className="p-md-5">
            <section className="search-container-section-order">
              <div>
                <Form.Control
                  style={{ backgroundColor: "white" }}
                  onChange={(e) => setSearchInput(e.target.value)}
                  className="font-size-1_2 "
                  placeholder="Search..."
                  type="text"
                  id="inputFilter"
                  aria-describedby="textFilter"
                />
              </div>
            </section>

            <div className="p-3">
              {radioCheckbox.map((check, index) => (
                <div key={index}>
                  <Form.Check
                    className="font-size-1_2 "
                    value={check.value}
                    type="checkbox"
                    id={`default-checkbox`}
                    label={check.name}
                    onClick={(e) => {
                      e.target.checked
                        ? orderCheckbox.push(e.target.value)
                        : orderCheckbox.splice(
                            orderCheckbox.indexOf(e.target.value),
                            1
                          );
                      setChecked(checked + 1);
                    }}
                  />
                </div>
              ))}
            </div>

            <div>
              {orderLoading ? (
                <div className="p-4">
                  <OrderDashboard
                    json={json}
                    searchInput={searchInput}
                    orderCheckbox={orderCheckbox}
                    checked={checked}
                  />
                </div>
              ) : (
                <div className="d-flex justify-content-center vh-25 align-items-center">
                  <ThreeDots color="#00BFFF" height={80} width={80} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Order;
